// GSM 2026-08 (UI refresh): add-to-cart drawer.
// Opened by theme.js AjaxCart.success with the /cart/add.js line item;
// shows EVERY cart line (Dom's 2026-08-25 preview feedback — not just
// the just-added item), the live subtotal, the free-shipping meter, and
// a similarity-ranked quick-add row (window.GSMSimilar). See
// snippets/gsm-cart-drawer.liquid for markup.
window.GSMCartDrawer = (function () {
  var els = null;
  var lastFocus = null;
  var escBound = false;

  function init() {
    if (els) return true;
    var drawer = document.getElementById('GsmCartDrawer');
    if (!drawer) return false;
    els = {
      drawer: drawer,
      overlay: document.getElementById('GsmDrawerOverlay'),
      items: document.getElementById('GsmDrawerItems'),
      totals: document.getElementById('GsmDrawerTotals'),
      similar: document.getElementById('GsmDrawerSimilar'),
      similarGrid: document.getElementById('GsmDrawerSimilarGrid'),
      close: document.getElementById('GsmDrawerClose')
    };
    els.close.addEventListener('click', close);
    els.overlay.addEventListener('click', close);
    if (!escBound) {
      escBound = true;
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen()) close();
      });
    }
    // Quick-add clicks inside the similar grid.
    els.similarGrid.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.gsm-drawer__add') : null;
      if (!btn || btn.disabled) return;
      var vid = btn.getAttribute('data-variant-id');
      if (!vid) return;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(vid), quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          btn.textContent = '✓ Added';
          btn.classList.add('is-added');
          bumpCartIcon();
          var dot = document.querySelectorAll('.site-header__cart-indicator');
          for (var i = 0; i < dot.length; i++) dot[i].classList.remove('hide');
          refreshTotals();
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Add';
        });
    });
    // − / + on the item rows: line-keyed /cart/change.js, then repaint
    // from the response. Every path repaints server truth, so the list,
    // counts, subtotal, and meter can never drift from the actual cart.
    if (els.items) els.items.addEventListener('click', function (e) {
      var ctl = e.target && e.target.closest ? e.target.closest('.gsm-drawer__step') : null;
      if (!ctl || ctl.disabled) return;
      var row = ctl.closest('.gsm-drawer__item');
      if (!row) return;
      var key = row.getAttribute('data-line-key');
      var qty = parseInt(row.getAttribute('data-qty'), 10) || 0;
      var next = ctl.classList.contains('gsm-drawer__step--plus') ? qty + 1 : qty - 1;
      if (!key || next < 0) return;
      var ctls = row.querySelectorAll('.gsm-drawer__step');
      for (var i = 0; i < ctls.length; i++) ctls[i].disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: next })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('change failed');
          return r.json();
        })
        .then(function (cart) {
          bumpCartIcon();
          paintCart(cart);
        })
        .catch(function () { refreshTotals(); });
    });

    // Keep totals fresh if the framing/diploma upsell modals (jQuery ajax)
    // add or change items while the drawer is open.
    if (window.jQuery) {
      window.jQuery(document).ajaxComplete(function (evt, xhr, settings) {
        if (!settings || !settings.url) return;
        if (/\/cart\/(add|change|update)/.test(settings.url) && isOpen()) refreshTotals();
      });
    }
    return true;
  }

  function isOpen() {
    return els && els.drawer.classList.contains('is-open');
  }

  function money(n) {
    var v = Math.round(Number(n) * 100) / 100;
    return '$' + v.toFixed(2);
  }

  // GSM 2026-08-25: Amazon-style free-shipping progress (Dom). The 9999
  // threshold mirrors the $99.99+ US Free Shipping rate in Shopify
  // shipping settings. renderMeter is exported: the cart page's
  // live-update script re-renders its liquid meter through it.
  var SHIP_THRESHOLD_CENTS = 9999;

  function renderMeter(el, totalCents) {
    if (!el) return;
    var pct = Math.min(100, Math.round((totalCents / SHIP_THRESHOLD_CENTS) * 100));
    var qualified = totalCents >= SHIP_THRESHOLD_CENTS;
    var msg = qualified
      ? '<strong>🎉 Your order qualifies for FREE U.S. shipping!</strong>'
      : 'You’re <strong>' + money((SHIP_THRESHOLD_CENTS - totalCents) / 100) +
        '</strong> away from <strong>FREE U.S. shipping</strong>';
    el.classList.toggle('is-qualified', qualified);
    el.innerHTML =
      '<div class="gsm-ship-meter__msg">' + msg + '</div>' +
      '<div class="gsm-ship-meter__track" role="progressbar" aria-label="Free shipping progress"' +
        ' aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '">' +
        '<div class="gsm-ship-meter__fill' + (qualified ? ' is-full' : '') + '" style="width:' + pct + '%"></div>' +
      '</div>';
    el.hidden = false;
  }

  function renderShipMeter(totalCents) {
    renderMeter(document.getElementById('GsmDrawerShip'), totalCents);
  }

  // One row per cart line, with its own − n + stepper keyed by the LINE
  // key (not the variant), so the count shown is exactly that line's
  // quantity — Dom's 2026-08-25 feedback: the drawer must never disagree
  // with the actual cart. /cart/change.js clamps to available inventory,
  // so the repaint after each change always shows server truth.
  function renderItemRow(item) {
    var row = document.createElement('div');
    row.className = 'gsm-drawer__item';
    row.setAttribute('data-line-key', item.key);
    var img = item.image ? sized(item.image, '160x160') : null;
    var variantBit = item.variant_title && item.variant_title !== 'Default Title'
      ? '<div class="gsm-drawer__added-variant"></div>'
      : '';
    row.innerHTML =
      (img ? '<img class="gsm-drawer__added-img" alt="" src="' + img + '">' : '<span class="gsm-drawer__added-img"></span>') +
      '<div class="gsm-drawer__added-info">' +
        '<a class="gsm-drawer__added-title"></a>' +
        variantBit +
        '<div class="gsm-drawer__added-price"></div>' +
        '<div class="gsm-drawer__line-stepper">' +
          '<button type="button" class="gsm-stepper__btn gsm-drawer__step gsm-drawer__step--minus" aria-label="Remove one from cart">&minus;</button>' +
          '<span class="gsm-stepper__qty" aria-live="polite"></span>' +
          '<button type="button" class="gsm-stepper__btn gsm-drawer__step gsm-drawer__step--plus" aria-label="Add one more to cart">+</button>' +
        '</div>' +
      '</div>';
    var titleEl = row.querySelector('.gsm-drawer__added-title');
    titleEl.textContent = item.product_title || item.title || '';
    if (item.url) titleEl.setAttribute('href', item.url);
    var vEl = row.querySelector('.gsm-drawer__added-variant');
    if (vEl) vEl.textContent = item.variant_title;
    updateRow(row, item);
    return row;
  }

  function updateRow(row, item) {
    row.setAttribute('data-qty', item.quantity);
    var q = row.querySelector('.gsm-stepper__qty');
    if (q) q.innerHTML = item.quantity + '<span class="visually-hidden"> in cart</span>';
    var p = row.querySelector('.gsm-drawer__added-price');
    if (p) p.textContent = money((item.final_price != null ? item.final_price : item.price) / 100);
    var ctls = row.querySelectorAll('.gsm-drawer__step');
    for (var i = 0; i < ctls.length; i++) ctls[i].disabled = false;
  }

  // Mirror the cart into the drawer's item list — EXACTLY. Rows for lines
  // still in the cart are MOVED and updated in place (no rebuild, so
  // nothing flickers); new lines get fresh rows in cart order (newest
  // first); rows whose line left the cart are REMOVED (a line stepped to
  // zero disappears here just like it does from the cart).
  function syncItems(cart, newKey) {
    if (!els || !els.items || !cart || !cart.items) return;
    var existing = {};
    var rows = els.items.querySelectorAll('.gsm-drawer__item');
    var i;
    for (i = 0; i < rows.length; i++) {
      existing[rows[i].getAttribute('data-line-key')] = rows[i];
      rows[i].classList.remove('is-new');
    }
    var frag = document.createDocumentFragment();
    cart.items.forEach(function (item) {
      var row = existing[item.key];
      if (row) {
        delete existing[item.key];
        updateRow(row, item);
      } else {
        row = renderItemRow(item);
      }
      if (newKey && item.key === newKey) {
        void row.offsetWidth; // restart the highlight animation
        row.classList.add('is-new');
      }
      frag.appendChild(row);
    });
    for (var k in existing) {
      if (Object.prototype.hasOwnProperty.call(existing, k) && existing[k].parentNode) {
        existing[k].parentNode.removeChild(existing[k]);
      }
    }
    els.items.appendChild(frag);
  }

  function sized(url, size) {
    if (!url) return url;
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url.replace(/(\.(?:jpg|jpeg|png|gif|webp))(\?.*)?$/i, '_' + size + '$1$2');
  }

  function bumpCartIcon() {
    var carts = document.querySelectorAll('.site-header__cart');
    for (var i = 0; i < carts.length; i++) {
      var c = carts[i];
      c.classList.remove('gsm-cart-bump');
      void c.offsetWidth; // restart the animation
      c.classList.add('gsm-cart-bump');
    }
  }

  function open() {
    if (!init()) return false;
    lastFocus = document.activeElement;
    els.drawer.classList.add('is-open');
    els.overlay.classList.add('is-open');
    document.body.classList.add('gsm-drawer-open');
    els.close.focus();
    return true;
  }

  function close() {
    if (!els) return;
    els.drawer.classList.remove('is-open');
    els.overlay.classList.remove('is-open');
    document.body.classList.remove('gsm-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // Paint a known-good cart everywhere the drawer shows cart state.
  function paintCart(cart, newKey) {
    if (!cart || !cart.items) return null;
    if (els && els.totals) {
      var n = cart.item_count;
      els.totals.innerHTML =
        '<span>Subtotal (' + n + (n === 1 ? ' item' : ' items') + ')</span>' +
        '<strong>' + money(cart.total_price / 100) + '</strong>';
    }
    syncItems(cart, newKey || null);
    renderShipMeter(cart.total_price);
    if (window.GSMCartBadge && window.GSMCartBadge.applyCart) {
      window.GSMCartBadge.applyCart(cart); // header badge + card quick-add steppers
    } else if (window.GSMCartBadge) {
      window.GSMCartBadge.paint(cart.item_count);
    }
    // Nudge other open tabs (e.g. a cart page being watched) to re-sync.
    if (typeof BroadcastChannel !== 'undefined') {
      try {
        (window.__gsmCartBC = window.__gsmCartBC || new BroadcastChannel('gsm-cart'))
          .postMessage({ total: cart.total_price });
      } catch (err) { /* ignore */ }
    }
    return cart;
  }

  function refreshTotals(newKey) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return paintCart(cart, newKey); })
      .catch(function () { return null; });
  }

  function renderSimilar(items) {
    if (!els.similar || !items.length) return;
    var frag = document.createDocumentFragment();
    items.forEach(function (p) {
      var tile = document.createElement('div');
      tile.className = 'gsm-drawer__tile';
      var off = p.compare_at && p.compare_at > p.price
        ? Math.round(((p.compare_at - p.price) * 100) / p.compare_at)
        : 0;
      tile.innerHTML =
        '<a class="gsm-drawer__tile-link" href="' + p.url + '">' +
          (p.image ? '<img class="gsm-drawer__tile-img" loading="lazy" alt="" src="' + p.image + '">' : '<span class="gsm-drawer__tile-img"></span>') +
          '<span class="gsm-drawer__tile-title"></span>' +
          '<span class="gsm-drawer__tile-price">' +
            (off >= 5 ? '<s>' + money(p.compare_at) + '</s> ' : '') + money(p.price) +
          '</span>' +
        '</a>' +
        '<button type="button" class="gsm-drawer__add" data-variant-id="' + p.variant_id + '">Add</button>';
      tile.querySelector('.gsm-drawer__tile-title').textContent = p.title;
      frag.appendChild(tile);
    });
    els.similarGrid.innerHTML = '';
    els.similarGrid.appendChild(frag);
    els.similar.hidden = false;
  }

  // Entry point from theme.js AjaxCart.success. Returns false when the
  // drawer markup isn't on the page so the caller can fall back.
  function openAfterAdd(item) {
    if (!open()) return false;
    if (els.similar) {
      els.similar.hidden = true;
      els.similarGrid.innerHTML = '';
    }
    // First open: paint the added line immediately while /cart.js loads;
    // syncItems moves (not rebuilds) it once the full cart arrives.
    if (els.items && !els.items.childElementCount) {
      syncItems({ items: [item] }, item.key);
    }
    refreshTotals(item.key).then(function (cart) {
      if (!window.GSMSimilar || !item.handle) return;
      var inCart = [];
      if (cart && cart.items) {
        cart.items.forEach(function (ci) { if (ci.handle) inCart.push(ci.handle); });
      }
      fetch('/products/' + item.handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (product) {
          return window.GSMSimilar.similar(
            { title: product.title, tags: product.tags, handle: item.handle },
            { count: 6, excludeHandles: inCart }
          );
        })
        .then(renderSimilar)
        .catch(function () {});
    });
    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  return { openAfterAdd: openAfterAdd, open: open, close: close, refreshTotals: refreshTotals, renderMeter: renderMeter };
})();
